import * as _ from 'lodash'
import {IDateRange, MessageType} from "../PA.Core/PA.Core.IF.Basic";

import {ErrorMessage_restate, ValidateDateRange, WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";

import {TPMPlanBO} from "./TPMPlanBO";


export class TPMPlanBOValidations {
    static ValidateBeforeDelete(aBO: TPMPlanBO): Promise<void> {

        return new Promise<void>((resolve, error) => {

            let aPlanPolicy: any = aBO.PolicyCollection.BOis._Editable
            let aPlanLock: any = aBO.PolicyCollection.BOis._Lock._status === "ReadOnly"


            ErrorMessage_restate(aBO.DeleteMessageProvider, !aPlanPolicy ,
                "UserIsntEditor", "User doesn't have Edit Access to Delete Plan")

            ErrorMessage_restate(aBO.DeleteMessageProvider, aPlanLock ,
                "LockedPlan", "Cannot delete a Locked Plan")

            resolve()
        })
    }
}